import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search, MapPin, Users, Calendar, GraduationCap } from "lucide-react";
import { api } from "../lib/api";
import { PageHero } from "../components/ui-parts";

export default function Districts() {
  const [list, setList] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/districts").then(r => setList(r.data)); }, []);
  const filtered = list.filter(d => d.name.toLowerCase().includes(q.toLowerCase()));
  return (
    <div data-testid="districts-page">
      <PageHero badge="Odisha Network" title="Our Work Across Odisha" subtitle="Explore volunteers, coordinators, courses and programmes in every district of Odisha." />
      <section className="section">
        <div className="container-narrow">
          <div className="relative max-w-lg mb-8">
            <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--js-muted)]" />
            <input data-testid="district-search" value={q} onChange={e => setQ(e.target.value)} placeholder="Search district…" className="w-full pl-10 pr-3 py-3 rounded-full border border-[var(--js-border)] bg-white" />
          </div>
          <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            {filtered.map(d => (
              <Link key={d.name} to={`/districts/${encodeURIComponent(d.name)}`} className="js-card p-5 block" data-testid={`district-card-${d.name}`}>
                <div className="flex items-start justify-between">
                  <div className="font-heading text-xl text-[var(--js-primary)]"><MapPin size={16} className="inline mr-1" />{d.name}</div>
                </div>
                <div className="mt-3 flex gap-3 text-xs text-[var(--js-muted)]">
                  <span className="flex items-center gap-1"><Users size={12} /> {d.volunteer_count}</span>
                  <span className="flex items-center gap-1"><GraduationCap size={12} /> {d.course_count}</span>
                  <span className="flex items-center gap-1"><Calendar size={12} /> {d.programme_count}</span>
                </div>
                {d.coordinator && <div className="mt-3 text-xs text-[var(--js-accent)]">Coordinator: {d.coordinator.full_name}</div>}
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
